// extracted by mini-css-extract-plugin
export default {"container":"CommoditiesAddChooseOrganism_container__Ddn0B"};